import { useContext } from "react";
import { AuthContext } from "./context";

export function useAuthHook() {
  return useContext(AuthContext);
}
